import { render, staticRenderFns } from "./showreel.vue?vue&type=template&id=a1cb21e4&scoped=true&"
import script from "./showreel.vue?vue&type=script&lang=js&"
export * from "./showreel.vue?vue&type=script&lang=js&"
import style0 from "./showreel.vue?vue&type=style&index=0&id=a1cb21e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cb21e4",
  null
  
)

export default component.exports